import script from "./ModalManageClientCar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalManageClientCar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__